export const getArchive = state => state.archive;
